import React from 'react';
import {Box} from '@mui/material';
import BlogPage from '../components/BlogPage';

const Blogs = () => {
  return (
    <Box sx={{pt:4}}>
      <BlogPage/>
    </Box>
  )
}

export default Blogs;